// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Project$BenfaerberBlog from "../lib/Project.bs.js";

function s(prim) {
  return prim;
}

function LanguageSelector$ImageBadge(props) {
  var setLanguage = props.setLanguage;
  var selectedLanguage = props.selectedLanguage;
  var language = props.language;
  var info = Project$BenfaerberBlog.getLanguageInfo(language);
  var selected = language === selectedLanguage ? "selected" : "";
  var onClick = function (param) {
    if (language === selectedLanguage) {
      return setLanguage(function (param) {
                  return "Other";
                });
    } else {
      return setLanguage(function (param) {
                  return language;
                });
    }
  };
  var name = language === "Other" ? "All" : info.name;
  return JsxRuntime.jsx("button", {
              children: name + " (" + String(props.count) + ")",
              className: "button language-button m-2 " + selected,
              style: {
                backgroundColor: info.color
              },
              onClick: onClick
            });
}

var ImageBadge = {
  make: LanguageSelector$ImageBadge
};

function LanguageSelector(props) {
  var setLanguage = props.setLanguage;
  var projects = props.projects;
  var language = props.language;
  return JsxRuntime.jsx("div", {
              children: Belt_Array.mapWithIndex(Project$BenfaerberBlog.allLanguages, (function (i, l) {
                      var count = l === "Other" ? projects.length : Belt_Array.keep(projects, (function (p) {
                                return p.language === l;
                              })).length;
                      return JsxRuntime.jsx(LanguageSelector$ImageBadge, {
                                  language: l,
                                  count: count,
                                  selectedLanguage: language,
                                  setLanguage: setLanguage
                                }, String(i));
                    })),
              className: "is-flex is-flex-wrap-wrap ",
              style: {
                justifyContent: "center"
              }
            });
}

var make = LanguageSelector;

export {
  s ,
  ImageBadge ,
  make ,
}
/* react/jsx-runtime Not a pure module */
